export function renderCommandHelpText(
  command: 'add' | 'create' | 'generate' | 'init' | 'seed' | 'update'
): string {
  switch (command) {
    case 'add':
      return `
Examples:
  $ betterstart add blog
  $ betterstart add r2 --integration`
    case 'create':
      return `
Examples:
  $ betterstart create entity
  $ betterstart create form contact`
    case 'generate':
      return `
Examples:
  $ betterstart generate posts
  $ betterstart generate --all --skip-migration`
    case 'init':
      return `
Examples:
  $ betterstart init
  $ betterstart init my-app --yes --database-url <url>
  $ betterstart init --yes --database-provider vercel --deploy-provider vercel --json`
    case 'seed':
      return `
Examples:
  $ betterstart seed
  $ BETTERSTART_ADMIN_PASSWORD=<password> betterstart seed --email admin@example.com`
    case 'update':
      return `
Examples:
  $ betterstart update --list
  $ betterstart update media-field
  $ betterstart update --all --yes`
  }
}
